import {FC, InputHTMLAttributes, useRef} from 'react';
import {generatePassword} from '../../modules/utils';
import check_svg from '../../assets/images/icons/check.svg';
import {useTranslation} from "react-i18next";
import {ReactSVG} from "react-svg";

interface Props extends InputHTMLAttributes<any> {
  label?: string;
  id?: string;
  className?: string;
  small?: boolean;
}

const Checkbox: FC<Props> = ({
                               label,
                               className,
                               id,
                               small,
                               ...props
                             }) => {
  const {t} = useTranslation();
  const _id = useRef('check_' + generatePassword());
  return (
    <div className={`form-check${small ? ' form-check-sm' : ''} ${className ?? ''}`}>
      <input
        {...props}
        className={`form-check-input`}
        type="checkbox"
        id={id || _id.current}
      />
      <div className='form-check-custom'>
        <ReactSVG src={check_svg} className={'react-icon'} />
      </div>
      {label
        ?
        <label className="form-check-label cursor-pointer ps-3" htmlFor={id || _id.current}>
          {t(label)}
        </label>
        :
        null
      }
    </div>
  );
};

export default Checkbox;
